import React from "react"
import { FormattedMessage, defineMessage, MessageDescriptor, useIntl } from "react-intl"
import { Box, Select, SelectChangeEvent, MenuItem, Typography } from "@carrotfertility/carotene-core"
import { useDoulaServicesSearchParam } from "#/pages/provider-finder/utils/providerFinderSearchUrl"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { useProviderTypeSearched } from "#/pages/provider-finder/components/results/useProviderTypeSearched"
import { useConvertTranslatedLabel } from "#/services/common-forms/useConvertTranslatedLabel"
import { renderSelectWithPlaceholderMultiSelect } from "#/services/common-forms/renderSelectValueUtil"

export const DOULA_SERVICES_SELECT_OPTIONS: { label: MessageDescriptor; value: string }[] = [
  {
    value: "birth",
    label: defineMessage({ defaultMessage: "Birth" })
  },
  {
    value: "postpartum",
    label: defineMessage({ defaultMessage: "Postpartum" })
  },
  {
    value: "pregnancy loss",
    label: defineMessage({ defaultMessage: "Pregnancy loss" })
  }
]
export function DoulaServicesFilter(): JSX.Element {
  const intl = useIntl()
  const [selectedServices, setSelectedServices]: [string[], (services: string[]) => void] =
    useDoulaServicesSearchParam()
  const { mutate: trackMemberAction } = useMemberActionTracking()
  const { isDoulasSearched } = useProviderTypeSearched()
  const translatedOptions = useConvertTranslatedLabel(DOULA_SERVICES_SELECT_OPTIONS)

  return isDoulasSearched ? (
    <Box display="flex" flexDirection="column" gap={(theme) => theme.spacing(theme.tokens.spacing.xxs)}>
      <Typography
        id="doula-services-filter-select-label"
        variant="h6"
        paddingLeft={(theme) => theme.spacing(theme.tokens.spacing.md)}
      >
        <FormattedMessage defaultMessage="Doula services" />
      </Typography>
      <Select
        renderValue={renderSelectWithPlaceholderMultiSelect(
          translatedOptions as { label: string; value: string }[],
          intl.formatMessage({ defaultMessage: "Select service" })
        )}
        aria-labelledby="doula-services-filter-select-label"
        multiple
        value={selectedServices}
        onChange={(event: SelectChangeEvent<string[]>) => {
          const value = event.target.value as string[]
          setSelectedServices(value)
          if (value?.length) {
            trackMemberAction({
              memberActionTaken: MemberActions.PROVIDER_FINDER_DOULA_SERVICE_FILTER_SEARCHED,
              metaData: {
                doulaServices: value
              }
            })
          }
        }}
        sx={{
          "& .MuiSelect-select": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent"
          }
        }}
      >
        {DOULA_SERVICES_SELECT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {intl.formatMessage(option.label)}
          </MenuItem>
        ))}
      </Select>
    </Box>
  ) : null
}
